import React from 'react';
import clsx from 'clsx';
import { Dropdown, Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import entityIcons from '@/constants/images';
import UserIcon from '../../components/UserIcon';

const listUser = (user) => ({
  key: `user_dropdown_item_${user.uuid}`,
  text: user.name,
  value: user.uuid,
  description: user.role?.name,
  icon: (<UserIcon archived={user.archived} approved={user.approved} />),
});

const listUserGroup = (userGroup, intl) => ({
  key: `user_dropdown_item_${userGroup.code}`,
  text: userGroup.name,
  value: userGroup.code,
  description: intl.formatMessage({ id: 'icon.usergroup' }),
  icon: (<Icon name={entityIcons.usergroup} title={intl.formatMessage({ id: 'icon.usergroup' })} />),
});

const listItems = (members, intl) => members.map(
  (member) => (member.uuid ? listUser(member) : listUserGroup(member, intl)),
);

const MembersDropdown = ({
  autoFocus,
  className,
  disabled,
  filter,
  members,
  onChange,
  onFilterChange,
  readStatus,
  text,
  usersOnly,
}) => {
  const intl = useIntl();
  return (
    <Dropdown
      placeholder={intl.formatMessage({ id: usersOnly ? 'find.users.placeholder' : 'find.members.placeholder' })}
      options={listItems(members, intl)}
      fluid
      search={(options) => options}
      searchQuery={filter}
      selection
      multiple
      autoFocus={autoFocus}
      disabled={disabled}
      className={clsx('aridhia-users-dropdown mt-0', className)}
      value={text}
      onSearchChange={
            (e, { searchQuery }) => { onFilterChange(searchQuery); }
          }
      onChange={(e, { value }) => { onChange(value); }}
      loading={readStatus === states.PENDING}
      noResultsMessage={intl.formatMessage({ id: usersOnly ? 'find.users.none' : 'find.members.none' })}
    />
  );
};

export default MembersDropdown;
